import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    center: Object,
    markers: Array
  }

  connect() {
    window.dispatchEvent(new CustomEvent("delivery:client-runs-map-update", {
      detail: {
        center: this.centerValue,
        markers: this.markersValue
      }
    }))
  }
}
